export const BONUS_POINTS = 'bonus-points'

export const BONUS_TYPES = ['login', 'quiz', 'multi_selections_quiz']
